'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMessageReceived = defaultMessageReceived;

var _receivedIncomingMessage = require('./ChatActions/receivedIncomingMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _isFromBot = require('conversations-schema/pubnub-message/operators/isFromBot');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _getResponderByIdAndType = require('../responders/operators/getResponderByIdAndType');

var _getResponders = require('../responders/selectors/getResponders');

function defaultMessageReceived(message, channel, threadId) {
  return function (dispatch, getState) {
    var responders = (0, _getResponders.getResponders)(getState());
    var senderType = (0, _isFromBot.isFromBot)(message) ? _senderTypes.BOT : _senderTypes.AGENT;
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);
    var responder = (0, _getResponderByIdAndType.getResponderByIdAndType)({
      responders: responders,
      senderType: senderType,
      senderId: senderId
    });
    dispatch((0, _receivedIncomingMessage.receivedIncomingMessage)({
      message: message,
      channel: channel,
      responder: responder,
      shouldNotify: true,
      threadId: threadId
    }));
  };
}